<!-- Toolbar / Header -->
<div #header class="w-full">
  <app-modal-header #modal_header [isDialog]="isDialog" [state]="state" [label]="title" (onOkClick)="doOk($event)"
    (onReady)="modalHeaderReady($event)" (onCancelClick)="doCancel($event)">
  </app-modal-header>
</div>

<div class="jk-content">
  <div class="jk-grid-cols-2">
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jkcheckboxYN label="星號" #WD027Com id="WD027" [(valueYN)]="item.WD027" [readonly]="isBrowse">
      </app-jkcheckboxYN>
      <app-jkdatefield label="工作日期" #WD002Com id="WD002" [(value)]="item.WD002" [required]="true" placeholder="工作日期"
        [readonly]="isBrowse">
      </app-jkdatefield>
      <app-jkedit label="星期" #WD018Com id="WD018" [(value)]="item.WD018" placeholder="星期" [readonly]="isBrowse">
      </app-jkedit>
      <app-jkedit label="主旨" #WD004Com id="WD004" [(value)]="item.WD004" placeholder="主旨" [readonly]="isBrowse">
      </app-jkedit>
    </div>
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jktextarea height="250px" label="內文" #WD003Com id="WD003" [(value)]="item.WD003" placeholder="內文"
        [readonly]="isBrowse">
      </app-jktextarea>
      <app-jktextarea height="250px" label="RTF內文" #WD026Com id="WD026" [(value)]="item.WD026" placeholder="RTF內文"
        [readonly]="isBrowse">
      </app-jktextarea>
    </div>
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jkcombobox label="大分類" #WD015Com id="WD015" [(value)]="item.WD015" [items]="srv.MtrWd015List"
        [readonly]="isBrowse">
      </app-jkcombobox>
      <app-jkedit label="中分類" #WD016Com id="WD016" [(value)]="item.WD016" placeholder="中分類" [readonly]="isBrowse">
      </app-jkedit>
      <app-jkedit label="小分類" #WD024Com id="WD024" [(value)]="item.WD024" placeholder="小分類" [readonly]="isBrowse">
      </app-jkedit>
    </div>
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jkedit label="工作者" #WD014Com id="WD014" [(value)]="item.WD014" placeholder="工作者" [readonly]="isBrowse">
      </app-jkedit>
      <app-jkedit label="客戶代號" #WD021Com id="WD021" [(value)]="item.WD021" [required]="true" placeholder="客戶代號"
        [readonly]="isBrowse">
      </app-jkedit>
      <app-jknumberedit label="計費時數" #WD025Com id="WD025" [(value)]="item.WD025" placeholder="計費時數"
        [readonly]="isBrowse">
      </app-jknumberedit>
    </div>
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jkcombobox label="狀態" #WD011Com id="WD011" [(value)]="item.WD011" [items]="srv.mtrWd011List"
        [readonly]="isBrowse">
      </app-jkcombobox>
      <app-jkcheckboxYN label="結案碼" #WD017Com id="WD017" [(valueYN)]="item.WD017" [readonly]="isBrowse">
      </app-jkcheckboxYN>
    </div>
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jkedit label="提醒碼" #WD010Com id="WD010" [(value)]="item.WD010" placeholder="提醒碼" [readonly]="isBrowse">
      </app-jkedit>
      <app-jkdatefield label="提醒日期" #WD005Com id="WD005" [(value)]="item.WD005" placeholder="提醒日期"
        [readonly]="isBrowse">
      </app-jkdatefield>
      <app-jktext label="提醒時間" [value]="item.WD006">
      </app-jktext>
    </div>
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jkedit label="優先順序" #WD012Com id="WD012" [(value)]="item.WD012" placeholder="優先順序" [readonly]="isBrowse">
      </app-jkedit>
      <app-jknumberedit label="進度" #WD013Com id="WD013" [(value)]="item.WD013" placeholder="進度" [readonly]="isBrowse">
      </app-jknumberedit>
      <app-jknumberedit label="預估時數" #WD020Com id="WD020" [(value)]="item.WD020" placeholder="預估時數"
        [readonly]="isBrowse">
      </app-jknumberedit>
    </div>
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jkcheckboxYN label="私人的" #WD022Com id="WD022" [(valueYN)]="item.WD022" [readonly]="isBrowse">
      </app-jkcheckboxYN>
      <app-jkcombobox label="週期" #WD023Com id="WD023" [(value)]="item.WD023" [items]="srv.mtrWd023List"
        [readonly]="isBrowse">
      </app-jkcombobox>
      <app-jknumberedit label="金額" #WD019Com id="WD019" [(value)]="item.WD019" placeholder="金額" [readonly]="isBrowse">
      </app-jknumberedit>
    </div>
    <div class="ai-section-header"> <mat-divider></mat-divider> </div>
    <div class="flex">
      <app-jktext label="來源單號" [value]="item.WD028">
      </app-jktext>
      <app-jktext label="建檔時間" [value]="item.WD001">
      </app-jktext>
    </div>

  </div>
</div>
<mat-toolbar class="jk-footer-toolbar">
</mat-toolbar>
<!-- 單頭編輯結束 -->
